import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { budgetDetailsByIdDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdDataSelector";
import { integrationsDataAsObjectSelector } from "@/store/integrations/selectors/integrationsDataAsObjectSelector";
import { Integration } from "@/services/cloudchipr.api";

export const budgetDetailsIntegrationSelector = createDraftSafeSelector(
  [budgetDetailsByIdDataSelector, integrationsDataAsObjectSelector],
  (budget, integrations): Integration[] => {
    return (
      budget?.notifications?.map(
        (notification) =>
          notification.integration_id &&
          integrations[notification.integration_id],
      ) ?? []
    ).filter((integration) => !!integration);
  },
);
